import { render, staticRenderFns } from "./AdminManagement.vue?vue&type=template&id=0a4a97ef"
import script from "./admin-management.ts?vue&type=script&lang=ts&external"
export * from "./admin-management.ts?vue&type=script&lang=ts&external"
import style0 from "./admin-management.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports